import React from "react";

import { ApproveSheet } from "~/pages/purchase-orders/components/order-detail/ApproveSheet";
import { RejectSheet } from "~/pages/purchase-orders/components/order-detail/RejectSheet";
import { SalesRequest } from "~/types/client";

interface OrderDetailDialogSheetsProps {
  isApproveSheetOpen: boolean;
  setIsApproveSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isRejectSheetOpen: boolean;
  setIsRejectSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rejectionReason: string;
  setRejectionReason: React.Dispatch<React.SetStateAction<string>>;
  customReason: string;
  setCustomReason: React.Dispatch<React.SetStateAction<string>>;
  isSubmitting: boolean;
  selectedOrder: SalesRequest;
  clientName: string;
  seller: {
    name: string;
    lastname: string;
    email: string;
  };
  handleApprove: () => Promise<void>;
  handleReject: () => Promise<void>;
  requiresPrepayment?: boolean;
}

export const OrderDetailDialogSheets: React.FC<
  OrderDetailDialogSheetsProps
> = ({
  isApproveSheetOpen,
  setIsApproveSheetOpen,
  isRejectSheetOpen,
  setIsRejectSheetOpen,
  rejectionReason,
  setRejectionReason,
  customReason,
  setCustomReason,
  isSubmitting,
  selectedOrder,
  clientName,
  seller,
  handleApprove,
  handleReject,
  requiresPrepayment = false,
}) => {
  return (
    <>
      <ApproveSheet
        isOpen={isApproveSheetOpen}
        setIsOpen={setIsApproveSheetOpen}
        selectedOrder={selectedOrder}
        clientName={clientName}
        seller={seller}
        isSubmitting={isSubmitting}
        onApprove={handleApprove}
      />

      <RejectSheet
        isOpen={isRejectSheetOpen}
        setIsOpen={setIsRejectSheetOpen}
        rejectionReason={rejectionReason}
        setRejectionReason={setRejectionReason}
        customReason={customReason}
        setCustomReason={setCustomReason}
        isSubmitting={isSubmitting}
        onReject={handleReject}
      />
    </>
  );
};
